import React from 'react'
import { withRouter } from 'react-router-dom'
import { Select, Button, Col, Row, Table, Message, Popover, Input } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import './style.css'
import {
  getStores,
  getCategories,
  getCommodities,
  deleteCommodity,
  offCommodity,
} from '../../../api/businessCommodity'
import CommodityDetail from '../components/commodityDetail'
import { fixPhotoUrl } from '../../../util/index'

class Merchandise extends React.Component {
  state = {
    list: [],
    storeList: [],
    categoryList: [],
    storeId: '',
    categoryId: '',
    keyword: '',
    isFirstLoad: true,
    chosenItem: {},
  }

  constructor(props) {
    super(props)
    this.CommodityDetailRef = React.createRef()
  }

  componentDidMount() {
    this.getStoreList()
    this.getCategoryList(this.getList)
  }

  // 获取仓库列表
  getStoreList = async () => {
    const { data, detail, status } = await getStores()
    if (status == 1) {
      this.setState({ storeList: data })
    } else {
      Message.error(detail)
    }
  }

  // 获取分类列表
  getCategoryList = async (callback) => {
    const club_id = sessionStorage.getItem('club_id')
    const { data, detail, status } = await getCategories(club_id)
    if (status == 1) {
      this.setState({
        categoryList: data,
        // categoryId: data.length > 0 ? data[0].id : '',
      })
      callback && callback('', '')
      this.setState({ isFirstLoad: false })
      this.forceUpdate()
    } else {
      Message.error(detail)
    }
  }

  // 获取主界面列表
  getList = async (storeId, categoryId) => {
    if (this.state.isFirstLoad) {
      const { data, detail, status } = await getCommodities(storeId, categoryId)
      if (status == 1) {
        this.setState({ list: data })
      } else {
        Message.error(detail)
      }
    } else {
      const { data, detail, status } = await getCommodities(
        this.state.storeId,
        this.state.categoryId,
        this.state.keyword
      )
      if (status == 1) {
        this.setState({ list: data })
      } else {
        Message.error(detail)
      }
    }
  }

  // 触发子组件打开模态窗
  openChildModal = (title, data) => {
    this.CommodityDetailRef.current.openModal(title, data)
  }

  // 点击商品详情, 获取选择商品的数据
  openItemDetail = (record, title) => {
    this.setState({ chosenItem: record })
    this.openChildModal(title, record)
  }

  // 删除商品
  deleteItem = async (record) => {
    const ids = []
    ids.push(record.id)
    const { data, status, detail } = await deleteCommodity({ ids: ids })
    if (status == 1) {
      Message.success('删除成功')
      this.getList()
    } else {
      Message.error(detail)
    }
  }

  // 下架商品
  offItem = async (record) => {
    const ids = []
    ids.push(record.id)
    const { data, status, detail } = await offCommodity({ ids: ids })
    if (status == 1) {
      Message.success('下架成功')
      this.getList()
    } else {
      Message.error(detail)
    }
  }

  render() {
    // 主界面列表
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
      },
      {
        title: '商品图片',
        dataIndex: 'photoUrl',
        render: (text, record, index) => {
          return (
            <a href={fixPhotoUrl(text)} target="_blank">
              <img className="product_pic" src={fixPhotoUrl(text)} />
            </a>
          )
        },
      },
      {
        title: '商品名称',
        dataIndex: 'name',
      },
      {
        title: '售价',
        dataIndex: 'amount',
        render: (text, record, index) => {
          return (text / 100).toFixed(2)
        },
      },
      {
        title: '库存',
        dataIndex: 'quantity',
        render: (text, record, index) => {
          if (record.isNonStandard) {
            return '-'
          } else {
            return text
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'handling',
        render: (text, record, index) => {
          return (
            <div>
              <Button
                className="mr-20"
                type="primary"
                onClick={() => {
                  this.openItemDetail(record, '商品详情')
                }}
              >
                详情
              </Button>
              <Button
                className="mr-20 success_btn"
                type="primary"
                onClick={() => {
                  this.openItemDetail(record, '商品进货')
                }}
              >
                进货
              </Button>

              {record.isNonStandard ? (
                <Popover
                  content={
                    <span style={{ color: '#ccc' }}>手工商品不可调货</span>
                  }
                >
                  <Button className="mr-20" type="primary" disabled>
                    调货
                  </Button>
                </Popover>
              ) : (
                <Button
                  className="mr-20"
                  type="primary"
                  onClick={() => {
                    this.openItemDetail(record, '商品调拨')
                  }}
                >
                  调货
                </Button>
              )}

              {record.isNonStandard ? (
                <Popover
                  content={
                    <span style={{ color: '#ccc' }}>手工商品不可退库</span>
                  }
                >
                  <Button className="mr-20" type="danger" disabled>
                    退库
                  </Button>
                </Popover>
              ) : (
                <Button
                  className="mr-20 brown_btn"
                  type="danger"
                  onClick={() => {
                    this.openItemDetail(record, '商品退库')
                  }}
                >
                  退库
                </Button>
              )}

              <Button
                className="mr-20 blue_btn"
                type="primary"
                onClick={() => {
                  this.openItemDetail(record, '商品流水')
                }}
              >
                商品流水
              </Button>

              <Popconfirm
                title="确认要下架此商品？"
                onConfirm={() => {
                  this.offItem(record)
                }}
                okText="是"
                cancelText="否"
              >
                <Button className="mr-20" type="default">
                  下架商品
                </Button>
              </Popconfirm>

              {/* <Popconfirm
                title="确认要删除此商品？"
                onConfirm={() => {
                  this.deleteItem(record)
                }}
                okText="是"
                cancelText="否"
              >
                <Button className="mr-20" type="danger">
                  删除商品
                </Button>
              </Popconfirm> */}
            </div>
          )
        },
      },
    ]

    const { storeList, categoryList } = this.state
    return (
      <div>
        <Row>
          <Col span={12}>
            <Select
              placeholder="选择仓库"
              className="mr-20 title_slct"
              onChange={(value) => {
                this.setState({ storeId: value })
              }}
              defaultValue=""
            >
              <Select.Option value="">全部仓库</Select.Option>
              {storeList &&
                storeList.map((item, idx) => {
                  return (
                    <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  )
                })}
            </Select>

            <Select
              placeholder="选择类型"
              className="mr-20 title_slct"
              onChange={(value) => {
                this.setState({ categoryId: value })
              }}
              value={this.state.categoryId}
            >
              <Select.Option value="">全部类型</Select.Option>
              {categoryList &&
                categoryList.map((item, idx) => {
                  return (
                    <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  )
                })}
            </Select>

            <Input
              style={{ width: '200px', marginRight: '20px' }}
              placeholder="输入商品名称搜索"
              onChange={(e) => {
                this.setState({ keyword: e.target.value })
              }}
              value={this.state.keyword}
            ></Input>

            <Button type="primary" onClick={this.getList}>
              显示
            </Button>
          </Col>

          <Col span={6} offset={6}>
            <div style={{ float: 'right' }}>
              <Button
                type="primary"
                className="mr-20"
                onClick={() => {
                  this.openChildModal('新增商品')
                }}
              >
                添加商品
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  this.openChildModal('下架商品')
                }}
              >
                下架商品
              </Button>
            </div>
          </Col>
        </Row>

        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={this.state.list}
          className="mt-20"
        ></Table>

        <CommodityDetail
          ref={this.CommodityDetailRef}
          categoryList={this.state.categoryList}
          storeList={this.state.storeList}
          chosenItem={this.state.chosenItem}
          getList={this.getList}
        ></CommodityDetail>
      </div>
    )
  }
}
export default withRouter(Merchandise)



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/Merchandise/index.js